import { gql } from "@apollo/client";

export const MY_NOTIFICATIONS_QUERY = gql`
  query MyNotifications {
    myNotifications {
      id
      title
      content
      createdAt
      order_no
      order_id
      is_read
    }
  }
`;

export const MARK_MY_NOTIFICATIONS_READ_MUTATION = gql`
  mutation MarkMyNotificationsRead {
    markMyNotificationsRead {
      message
    }
  }
`;
